import React from 'react';
import { Data } from '@styled-icons/boxicons-regular/Data';
import { DreamBlock } from '@typedream/core';
import styled, { css } from 'styled-components';
import { BLOCK_ELEMENT_KEY } from './types';
import { getTPlugin, useTPlateEditorRef } from '../../../../plate';
import { CollectionDataPluginOptions } from '../../types';
import { KEY_COLLECTION_CONNECT_DATA } from '../../../../pluginKeys';

const TagStyle = css`
    padding: 2px 5px;
    font-size: 15px;
    margin-top: -2px;
    color: var(--text-lighter) !important;
    background-color: var(--background-highlight);
    border-radius: 2px;
    margin-right: 2px;
    line-height: inherit;
    vertical-align: middle;
    user-select: none !important;
    -webkit-user-select: none !important;
    font-weight: normal;
    letter-spacing: normal;
`;

const TagContainerDiv = styled.div`
    ${TagStyle};
    position: absolute;
    top: 4px;
    opacity: 0.5;
    left: 2px;
    transition: 0.2s all;
    width: fit-content !important;
    height: fit-content !important;
    cursor: auto;
    &:hover {
        opacity: 1;
    }
`;
// For showing that this block is connected to a data source
function CollectionDataElementBlockTag({ element }: { element: DreamBlock }) {
  const editor = useTPlateEditorRef();
  const { options } = getTPlugin<CollectionDataPluginOptions>(editor, KEY_COLLECTION_CONNECT_DATA);

  const { showSchema } = options as CollectionDataPluginOptions;
  const dataKey = element?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS]
    ? element?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS]?.filter(
      (k) => k.blockElementKey !== 'text',
    ).map((k) => k.schemaKey) : [];

  if (!showSchema
    || !element?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA]
     || (dataKey as string[])?.length <= 0) {
    return null;
  }
  return (
    <TagContainerDiv
      contentEditable={false}
      style={{
        userSelect: 'none',
      }}
    >
      <Data size={13} />
      {dataKey?.join(', ')}
    </TagContainerDiv>
  );
}

export default CollectionDataElementBlockTag;
